module.exports = __webpack_public_path__ + "img/w3_bookmark_square_white.6e5bd578.png";